module.exports = __webpack_public_path__ + "static/img/14000297.acc1962d.png";